import * as React from 'react';
import './styles.scss';
import { FunctionComponent } from 'react';

export type SpinnerProps = {
  active: boolean;
};

const BaseSpinner: FunctionComponent = () => {
  return <div className="spinner" />;
};

export const Spinner: FunctionComponent<SpinnerProps> = ({
  active
}: SpinnerProps) => <>{active && <BaseSpinner />}</>;

export const SpinnerOverlay: FunctionComponent<SpinnerProps> = ({
  active
}: SpinnerProps) => {
  return (
    <>
      {active && (
        <div className="overlay">
          <BaseSpinner />
        </div>
      )}
    </>
  );
};
